var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.beneficiaryValues),function(item,index){return _c('Beneficiary',{key:index,ref:"beneficiary",refInFor:true,attrs:{"value":item,"globalPercentage":_vm.globalPercentage,"index":index},on:{"onDelete":function($event){return _vm.onDelete(index)},"input":function($event){return _vm.onInput($event, index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }